import { alpha, SxProps, Theme } from "@mui/material/styles";

export const heroContainer: SxProps<Theme> = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    gap: 6,
    marginTop: 8,
    marginBottom:0,
    px: 2,
};

export const serviceHubImageContainer: SxProps<Theme> = {
    position: "relative",
    backgroundColor: (theme: Theme) => alpha(String(theme.palette.black), 0.8),
    width: "250px",
    height: "150px",
    borderRadius: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "rotate(-3deg)",
};

export const serviceHubImage: SxProps<Theme> = {
    transform: "rotate(3deg)",
    maxWidth: 300,
};

export const heroText: SxProps<Theme> = {
    fontWeight: "500",
    textTransform: "uppercase",
    fontSize: "1rem",
    color: (theme: Theme) => theme.palette.white,
    whiteSpace: "pre-line",
};

export const sponsorImage: SxProps<Theme> = {
    maxHeight: 40,
    mt: 0.5,
};
